var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"id":_vm.visualizerData.uuid,"src":_vm.imageSrc,"contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }